import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { SettingsSubjectContainersSubpage } from './SettingsSubjectContainersSubpage';
import { SettingsSubjectGroupsSubpage } from './SettingsSubjectGroupsSubpage';
import { SettingsSubjectsSubpage } from './SettingsSubjectsSubpage';

export const SettingsSetupSubjectsAndSubjectContainer = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <Tab
        variant='large'
        tabs={[
          {
            title: t('subject.title', { count: 2 }),
            value: 'subjects',
            content: <SettingsSubjectsSubpage />,
          },
          {
            title: t('subjectContainer.title', { count: 2 }),
            value: 'subjectsContainer',
            content: <SettingsSubjectContainersSubpage />,
          },
          {
            title: t('subjectGroup.title', { count: 2 }),
            value: 'subjectGroup',
            content: <SettingsSubjectGroupsSubpage />,
          },
        ]}
      />
    </Page>
  );
};
